import { render } from "./ClientSegments.vue?vue&type=template&id=300490fc&scoped=true"
import script from "./ClientSegments.vue?vue&type=script&lang=js"
export * from "./ClientSegments.vue?vue&type=script&lang=js"

import "./ClientSegments.vue?vue&type=style&index=0&id=300490fc&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-300490fc"]])

export default __exports__